import React, { useEffect, useState } from 'react';
import './Privacypolicy.css';
import Nav from '../LandingPage/Nav/Nav';
import Footer from '../LandingPage/Footer/Footer';
import { getwebsiteconfigs } from '../../Services/APIrequests'; 

function CancellationPolicy() {
  const [content, setContent] = useState('');

  const fetchCancellationPolicy = async () => {
    try {
      const response = await getwebsiteconfigs('Cancellation Policy');
      if (response?.data?.Status === 1) {
        const description = response?.data?.webSites?.description || '';
        setContent(description);
      }
    } catch (error) {
      console.error("Error fetching Cancellation Policy:", error);
    }
  };

  useEffect(() => {
    fetchCancellationPolicy();
  }, []);

  return (
    <div>
      <Nav />
      <div className='Privacy_Policy'>
        <div>
          <h1 className='Privacy_Policy_heading'>Cancellation Policy</h1>
          <div
            className="Privacy_Policy_content"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CancellationPolicy;
